module.exports = __webpack_public_path__ + "media/images/favicons/favicon-sunday-16x16-0ecc67f934b797b2462b4692e40a90f1.png";